import { AfterViewInit, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import { ChartData } from './chart-data'
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);

@Component({
    selector: 'matrix-tools-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: false
})
export class ChartComponent implements OnInit, AfterViewInit {
  @ViewChild('chartElement')
  private chartElement: ElementRef;
  private chart: Chart;

  @Input() title: string;
  @Input() chartData: ChartData[];
  @Input() showDownloadButton: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    // TODO seems like this is constantly hit, even when data doesn't change?, can we optimize?
    // it might be ChartJS fault somehow, turning off hover effects on the ChartJS config seemed to help, but loses hover features...  
    // So maybe we ignore this.. and delete the TODO if the MVP is working as expected??
    if (!this.chartElement || !changes.chartData
      || JSON.stringify(changes.chartData.previousValue) === JSON.stringify(changes.chartData.currentValue)) {
      return;
    }

    if (this.chart) {
      this.chart.destroy();
      this.ngAfterViewInit();
    }
  }

  ngAfterViewInit() {
    let maxY = 10;
    for (let chartData of this.chartData) {
      for (let point of chartData.points) {
        // Do not "un-zoom" for large sets of Change Logs
        if (point.y > maxY && chartData.name !== 'Change Log') {
          maxY = point.y;
        }
      }
    }
    // Ensure "un-zoomed" Change Log points are still shown
    for (let point of this.chartData.filter(data => data.name === 'Change Log')?.[0]?.points) {
      if (point.y > maxY) {
        point.y = maxY;
      }
    }

    this.chart = new Chart(this.chartElement.nativeElement, {
      type: 'line',
      options: {
        responsive: true,
        maintainAspectRatio: true,
        onClick: (evt) => {
          let points = this.chart.getActiveElements();
          if (points?.length) {
            let point = points[0];
            let element = point?.element;
            let message = element['$context']?.raw?.label
              ? element['$context']?.raw?.label
              : element['$context']?.raw?.y

            alert(message);
          }
        },
        plugins: {
          title: {
            display: true,
            text: this.title
          },
          legend: {
            labels: {
              usePointStyle: true
            }
          },
          annotation: {
            annotations: [{
              type: 'line',
              borderColor: 'green',
              xMin: '2023-09',
              xMax: '2023-09',//jeb date substring 7  //jebjebjebjeb hardcoded, get from DB!!!
              borderWidth: 5,
              label: {
                display: true,
                content: 'SEO Service - End Date',
              },
              click: function () {//jeb show the exact date when clicked (only the month is shown on the grid)
                alert('SEO Service - Start Date')
              },
            }]
          },
          //autocolors: false //jeb didn't work? bookmark
        },
        scales: {
          y: {
            min: 1,
            // Round Up to the nearest 10 of the max Y value
            max: Math.ceil(maxY / 10) * 10,
            // Lower numbers on top
            reverse: true
          }
        }
      },
      data: {
        datasets: this.chartData.map(dataset => ({   
          label: dataset.name,
          data: dataset.points as any[],
          showLine: dataset.showLine,
          backgroundColor: dataset.color,
          borderColor: dataset.color,
          pointStyle: dataset.pointStyle,
          borderWidth: 1,
          pointRadius: 10,
          pointHoverRadius: 20
        }))
      }
    });
  }

  downloadChart() {
    let temporaryDownloadLink = document.createElement('a') as HTMLAnchorElement;
    temporaryDownloadLink.href = this.chart.toBase64Image();
    temporaryDownloadLink.download = `${this.title}-${new Date().toLocaleDateString()}.png`;

    // Trigger the download
    temporaryDownloadLink.click();

    // Remove the temporary download link
    document.body.removeChild(temporaryDownloadLink);
  }

  emailChart() {
    alert('//jeb');
  }

  emailChartEveryMonth() {
    alert('//jeb');
  }
}
